import React from 'react';
import BackgroundImage from 'assets/landing/book-an-appointment.png';
import { Link } from 'react-router-dom';

export const BookAppointment = ({ data }) => {
  return (
    <section
      className="relative bg-cover bg-center bg-no-repeat text-gray-800 py-24 px-6 sm:px-12 lg:px-48"
      style={{ backgroundImage: `url(${data?.backgroundImage})` }}
    >
      {/* Content */}
      <div className="relative max-w-3xl">
        <h2 className="text-2xl sm:text-5xl font-semibold text-[#F8AF10] just-me-again-down-here-regular mb-4">
          {data?.label}
        </h2>
        <p className="text-sm sm:text-base text-gray-100 mb-8 leading-relaxed max-w-2xl">
          {data?.caption}
        </p>
        <a
          href={data?.btnLink}
          className="bg-[#AC3F1E] text-white uppercase text-sm sm:text-base tracking-wide px-6 py-3 transition-transform duration-300 hover:scale-105"
        >
          Book an appointment
        </a>
      </div>
    </section>
  );
};
